import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { on } from '@ember/modifier';
import Button from 'tio-ui/components/button';
import { PhUploadSimple } from 'ember-phosphor-icons';

const noop = () => {};

interface SubmitEvidenceBodySignature {
  Args: {
    /** Opens the evidence-upload flow (routes into the guided wizard). */
    onSubmit?: () => void;
  };
  Element: HTMLDivElement;
}

/**
 * Body of the "Submit your Evidence Items" task: explanatory copy + a CTA that
 * opens the evidence-upload flow. The required-items checklist is wired in PR#2.
 */
const SubmitEvidenceBody: TOC<SubmitEvidenceBodySignature> = <template>
  <div class="tio-col gap-4" ...attributes>
    <p class="tio-text-sm-normal tio-fg-secondary">
      {{t "tuition_assistance.applications.manage.tasks.submit_evidence_body"}}
    </p>
    <div>
      <Button
        @intent="primary"
        data-test-submit-evidence-cta
        {{on "click" (if @onSubmit @onSubmit noop)}}
      >
        <PhUploadSimple @size={{16}} class="mr-2" />
        {{t "tuition_assistance.applications.manage.tasks.submit_evidence_cta"}}
      </Button>
    </div>
  </div>
</template>;

export default SubmitEvidenceBody;
